import PageComponent from '../base/PageComponent';
import AOS from 'aos';

export default class AnimationContentModule extends PageComponent
{
    init() {
        AOS.init({
            offset: 200,
            duration: 800,
            easing: 'ease',
            delay: 100,
            disable: window.innerWidth < 992
        })
    }
}


// WEBPACK FOOTER //
// ./javascript/modules/AnimationContentModule.js